import decimal from 'decimal.js';
import { words } from 'globalState';
import { signWithKey } from 'keysAndSigning';
import {
  getUtxo,
  selectUtxoWatanabe,
  getRawTransaction,
  getFeeRate,
  calculateChangeWatanabe,
  buildUnsignedTransactionSendMona,
  signTransaction,
  broadcastTransaction,
} from 'blockchain';
import {
  devLog,
  decimalAdjust,
  wrapErrorWithCause,
  notificationMessageWithError,
  syncHttpRequest2,
  sendLog,
} from 'utils';

// 「ポイント合計:検索」ボタン押下 HANDLE CLICK GET POINT SUM
// ログイン前提とし、セッションのみに対応する。
async function handleClickGetPointSum(state, dispatch, activeCertification, consistentRead, keyPairs) {
  let request = {};
  let messages = {};
  let certifications = [];
  const now = Date.now();

  if (activeCertification === undefined || activeCertification === null) {
    activeCertification = {
      address: null,
    };
  }

  if (consistentRead === undefined || consistentRead === null) {
    consistentRead = false;
  }

  // state固定
  const stateFixed = {
    addressMain: state.getPointHistory.addressMain,
    signatureVersion: state.configMP.clientParameters.signatureVersion.getPointSum,
    walletType: state.walletType,
    addressCheck: 'strict',
  };

  // 有効なセッションに絞り込む。

  for (const address of Object.keys(state.session)) {

    // activeCertificationの場合は別処理
    if (address !== activeCertification.address) {

      // state固定
      stateFixed[address] = {
        // addressCoinType: state.session[address].addressCoinType,
        sessionId: state.session[address].sessionId,
        expirationOfSession: state.session[address].expirationOfSession,
      };

      if (stateFixed[address].expirationOfSession >= now + state.marginOfSessionTime) {
        certifications.push({
          // addressCoinType: stateFixed[address].addressCoinType,
          address: address,
          sessionId: stateFixed[address].sessionId,
          consistentRead: address === stateFixed.addressMain ? consistentRead : false,
        });
      }
    }
  }

  // activeCertificationの処理

  if (activeCertification.address !== null) {
    // -- state固定
    stateFixed[activeCertification.address] = {
      sessionId: activeCertification.sessionId,
      expirationOfSession: activeCertification.expirationOfSession,
    };

    // -- 有効だったら(まあほぼ有効なんだろうけど)プッシュ
    if (stateFixed[activeCertification.address].expirationOfSession >= now + state.marginOfSessionTime) {
      certifications.push({
        address: activeCertification.address,
        sessionId: stateFixed[activeCertification.address].sessionId,
        consistentRead: true, // activeCertificationは常に強力な整合性のある読み込みをする。
      });
    }
  }

  // const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

  // const extendedCertificationProperties = [
  //   { key: 'consistentRead', value: consistentRead },
  // ];

  // if (
  //   stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '' &&
  //   keyPairsInPool[stateFixed.addressMain]?.keyPair !== undefined
  // ) {
  //   certificationWithKey(state, dispatch, [ keyPairsInPool[stateFixed.addressMain].keyPair ], 'information', stateFixed, certifications, now, extendedCertificationProperties, 'matchedKey');
  // }
  // else if (keyPairs !== undefined && keyPairs !== null) {
  //   certificationWithKey(state, dispatch, keyPairs, 'information', stateFixed, certifications, now, extendedCertificationProperties, 'firstKey');
  // }
  // else if (stateFixed.walletType === 'mpurse') {
  //   await setSignatureByAddressMain(state, dispatch, stateFixed, certifications, now, extendedCertificationProperties, 'information');
  // }

  // addressMainは必須。事前ログイン前提なので、ここで鍵は求めない。

  if (
    // certifications.length === 0 ||
    // stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '' &&
    !certifications.map( certification => certification.address ).includes(stateFixed.addressMain)
  ) {
    // if (keyPairs === undefined || keyPairs === null) {
    //   if (stateFixed.walletType === 'nfc') {
    //     dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
    //     return {
    //       status: 'rejected',
    //       message: 'nfcRequired',
    //     };
    //   }
    //   else if (stateFixed.walletType === 'qr') {
    //     dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[state.language] });
    //     return {
    //       status: 'rejected',
    //       message: 'bcRequired',
    //     };
    //   }
    // }

    // dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }

  request.body = JSON.stringify({
    body: {
      action: 'pointSum',
      certifications: certifications,
    },
  });

  request.url = 'https://' + process.env.REACT_APP_KOM_API_DOMAIN + '/get_history';
  request.method = 'POST';

  messages = {
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, 'pointSum', undefined, undefined, messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {

    for (const address of Object.keys(response.body)) {
      // 署名した場合もろもろ更新(署名することは無いが、none はある。)
      if (response.body[address]['certificatedBy'] === 'signature') {

        // session更新
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address],
          value: {'sessionId': response.body[address]['sessionId'], 'expirationOfSession': response.body[address]['expirationOfSession']} });
      }
      else if (response.body[address]['certificatedBy'] === 'none') {
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address], value: { expirationOfSession: 0 } });
      }
    }

    // // addressMainが検索対象で、検索成功した場合
    // if (response.body[stateFixed.addressMain]?.certificatedBy === 'signature' || response.body[stateFixed.addressMain]?.certificatedBy === 'sessionId') {

    //   // addressMainが指定されていなかった場合は、dispatchする。
    //   if (state.getPointHistory.addressMain === undefined || state.getPointHistory.addressMain === null || state.getPointHistory.addressMain === '') {
    //     dispatch({ type: 'setStateMultiLayers', keys: ['getPointHistory', 'addressMain'], value: stateFixed.addressMain });
    //   }

    //   // // cookie情報更新(アドレス情報)
    //   // const userName = state.usersGeneralIndex[stateFixed.addressMain] !== undefined ? state.usersGeneralIndex[stateFixed.addressMain].userName : stateFixed.addressMain;
    //   // const cookiesNew = [
    //   //       {
    //   //         action: 'searchPurchaseHistory',
    //   //         addressType: 'addressMain',
    //   //         description: `${userName}`,
    //   //         time: now,
    //   //         address: stateFixed.addressMain
    //   //       },
    //   // ];

    //   // setAddressesInCookie(state, dispatch, cookies, setCookie, stateFixed.addressMain, cookiesNew);
    // }

    return { status: 'fulfilled', body: response.body };
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }
}

// 「購入:クリア」ボタン押下 HANDLE CLICK CLEAR PURCHASE
function handleClickClearPurchase(state, dispatch) {
  dispatch({ type: 'setState', key: 'purchasePoint',
    value: {
      purchaseNo: null,
      addressMain: '',
      addressPayFrom: '',
      amountToBuy: 800,
      signatureByAddressMain: '',
      signatureByAddressPayFrom: '',
      disabled: false,
      status: 'waitingForSignature',
    }
  });

  return;
}

// 「ポイント履歴:検索」ボタン押下 HANDLE CLICK GET POINT HISTORY
// ログイン前提とし、セッションのみに対応する。
async function handleClickGetPointHistory(state, dispatch, pagingIndex, activeCertification, consistentRead, keyPairs) {
  let request = {};
  let messages = {};
  let certifications = [];
  const now = Date.now();

  if (activeCertification === undefined || activeCertification === null) {
    activeCertification = {
      address: null,
    };
  }

  if (consistentRead === undefined || consistentRead === null) {
    consistentRead = false;
  }

  // state固定
  const stateFixed = {
    addressMain: state.getPointHistory.addressMain,
    lastEvaluatedKey: pagingIndex >= 1 ? state.getPointHistory.lastEvaluatedKey.point[pagingIndex - 1] : null,
    signatureVersion: state.configMP.clientParameters.signatureVersion.getPointHistory,
    walletType: state.walletType,
    addressCheck: 'strict',
  };

  // 有効なセッションに絞り込む。

  for (const address of Object.keys(state.session)) {

    // activeCertificationの場合は別処理
    if (address !== activeCertification.address) {

      // state固定
      stateFixed[address] = {
        // addressCoinType: state.session[address].addressCoinType,
        sessionId: state.session[address].sessionId,
        expirationOfSession: state.session[address].expirationOfSession,
      };

      if (stateFixed[address].expirationOfSession >= now + state.marginOfSessionTime) {
        certifications.push({
          // addressCoinType: stateFixed[address].addressCoinType,
          address: address,
          sessionId: stateFixed[address].sessionId,
          lastEvaluatedKey: address === stateFixed.addressMain ? stateFixed.lastEvaluatedKey : null,
          consistentRead: address === stateFixed.addressMain ? consistentRead : false,
        });
      }
    }
  }

  // activeCertificationの処理

  if (activeCertification.address !== null) {
    // -- state固定
    stateFixed[activeCertification.address] = {
      sessionId: activeCertification.sessionId,
      expirationOfSession: activeCertification.expirationOfSession,
    };

    // -- 有効だったら(まあほぼ有効なんだろうけど)プッシュ
    if (stateFixed[activeCertification.address].expirationOfSession >= now + state.marginOfSessionTime) {
      certifications.push({
        address: activeCertification.address,
        sessionId: stateFixed[activeCertification.address].sessionId,
        lastEvaluatedKey: null, // activeCertificationは常に先頭を検索する。
        consistentRead: true, // activeCertificationは常に強力な整合性のある読み込みをする。
      });
    }
  }

  // const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

  // const extendedCertificationProperties = [
  //   { key: 'consistentRead', value: consistentRead },
  // ];

  // if (
  //   stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '' &&
  //   keyPairsInPool[stateFixed.addressMain]?.keyPair !== undefined
  // ) {
  //   certificationWithKey(state, dispatch, [ keyPairsInPool[stateFixed.addressMain].keyPair ], 'information', stateFixed, certifications, now, extendedCertificationProperties, 'matchedKey');
  // }
  // else if (keyPairs !== undefined && keyPairs !== null) {
  //   certificationWithKey(state, dispatch, keyPairs, 'information', stateFixed, certifications, now, extendedCertificationProperties, 'firstKey');
  // }
  // else if (stateFixed.walletType === 'mpurse') {
  //   await setSignatureByAddressMain(state, dispatch, stateFixed, certifications, now, extendedCertificationProperties, 'information');
  // }

  // addressMainは必須。事前ログイン前提なので、ここで鍵は求めない。

  if (
    // certifications.length === 0 ||
    // stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '' &&
    !certifications.map( certification => certification.address ).includes(stateFixed.addressMain)
  ) {
    // if (keyPairs === undefined || keyPairs === null) {
    //   if (stateFixed.walletType === 'nfc') {
    //     dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
    //     return {
    //       status: 'rejected',
    //       message: 'nfcRequired',
    //     };
    //   }
    //   else if (stateFixed.walletType === 'qr') {
    //     dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[state.language] });
    //     return {
    //       status: 'rejected',
    //       message: 'bcRequired',
    //     };
    //   }
    // }

    // dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }

  request.body = JSON.stringify({
    body: {
      action: 'point',
      certifications: certifications,
    },
  });

  request.url = 'https://' + process.env.REACT_APP_KOM_API_DOMAIN + '/get_history';
  request.method = 'POST';

  messages = {
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, 'pointHistory', undefined, undefined, messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {

    for (const address of Object.keys(response.body)) {
      // 署名した場合もろもろ更新(署名することは無いが、none はある。)
      if (response.body[address]['certificatedBy'] === 'signature') {

        // session更新
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address],
          value: {'sessionId': response.body[address]['sessionId'], 'expirationOfSession': response.body[address]['expirationOfSession']} });
      }
      else if (response.body[address]['certificatedBy'] === 'none') {
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address], value: { expirationOfSession: 0 } });
      }
    }

    // addressMainが検索対象で、検索成功した場合
    if (response.body[stateFixed.addressMain]?.certificatedBy === 'signature' || response.body[stateFixed.addressMain]?.certificatedBy === 'sessionId') {
      if (response.body[stateFixed.addressMain].lastEvaluatedKey !== undefined) {
        dispatch({ type: 'setStateMultiLayers', keys: ['getPointHistory', 'lastEvaluatedKey', 'point', pagingIndex], value: response.body[stateFixed.addressMain].lastEvaluatedKey });
      }
      else {
        dispatch({ type: 'setStateMultiLayers', keys: ['getPointHistory', 'lastEvaluatedKey', 'point', pagingIndex], value: null });
      }

      dispatch({ type: 'setStateMultiLayers', keys: ['getPointHistory', 'pagingIndex', 'point'], value: pagingIndex });

      // addressMainが指定されていなかった場合は、dispatchする。
      if (state.getPointHistory.addressMain === undefined || state.getPointHistory.addressMain === null || state.getPointHistory.addressMain === '') {
        dispatch({ type: 'setStateMultiLayers', keys: ['getPointHistory', 'addressMain'], value: stateFixed.addressMain });
      }

      // // cookie情報更新(アドレス情報)
      // const userName = state.usersGeneralIndex[stateFixed.addressMain] !== undefined ? state.usersGeneralIndex[stateFixed.addressMain].userName : stateFixed.addressMain;
      // const cookiesNew = [
      //       {
      //         action: 'searchPurchaseHistory',
      //         addressType: 'addressMain',
      //         description: `${userName}`,
      //         time: now,
      //         address: stateFixed.addressMain
      //       },
      // ];

      // setAddressesInCookie(state, dispatch, cookies, setCookie, stateFixed.addressMain, cookiesNew);
    }

    return { status: 'fulfilled', body: response.body };
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }
}

// 「購入:署名」ボタン押下 HANDLE CLICK SIGN PURCHASE
// ずばり署名する鍵を渡す。
async function handleClickSignPurchase(state, dispatch, addressType, popupLayer, keyPair) {
  let addressActual;
  let signature;
  let request = {};
  let messages = {};
  let stateFixed = {};
  let bodyObj = {};
  let amountMona;

  // state固定
  if (popupLayer !== undefined && popupLayer !== null) {
    stateFixed = {
      exhibitNo: state.popup[popupLayer].body.exhibitNo,
      purchaseNo: state.popup[popupLayer].body.purchaseNo,
      addressMain: state.popup[popupLayer].body.addressMain,
      addressPayFrom: state.popup[popupLayer].body.addressPayFrom,
      amountToBuy: state.popup[popupLayer].body.amountToBuy,
      priceMona: state.configMP.clientParameters.priceMona,
      monatokaPointAddress: state.configMP.clientParameters.monatokaPointAddress,
      signatureByAddressMain: state.popup[popupLayer].body.signatureByAddressMain,
      signatureVersion: state.configMP.clientParameters.signatureVersion.purchasePoint,
      // addressCheck: state.addressCheck,
      addressCheck: 'strict',
      provisionalTransactionFee: state.config.clientParameters.provisionalTransactionFee,
    };
  }
  else {
    stateFixed = {
      purchaseNo: state.purchasePoint.purchaseNo,
      addressMain: state.purchasePoint.addressMain,
      addressPayFrom: state.purchasePoint.addressPayFrom,
      amountToBuy: state.purchasePoint.amountToBuy,
      priceMona: state.configMP.clientParameters.priceMona,
      monatokaPointAddress: state.configMP.clientParameters.monatokaPointAddress,
      signatureByAddressMain: state.purchasePoint.signatureByAddressMain,
      signatureVersion: state.configMP.clientParameters.signatureVersion.purchasePoint,
      // addressCheck: state.addressCheck,
      addressCheck: 'strict',
      provisionalTransactionFee: state.config.clientParameters.provisionalTransactionFee,
    };
  }

  // if (keyPairs !== undefined && keyPairs !== null) {
  //   keyPair = keyPairs[0];
  //   const result = getAddressFromKey(state, dispatch, keyPair);

  //   if (result.status === 'fulfilled') {
  //     stateFixed.addressMain = result.address;
  //     stateFixed.addressPayFrom = result.address;
  //   }
  //   else {
  //     dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
  //     return 'rejected';
  //   }
  // }

  // 必須項目チェック
  if (stateFixed.addressMain === undefined || stateFixed.addressMain === null || stateFixed.addressMain === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.mainAddressMustBeFilled[state.language] });
    return { status: 'rejected' };
  }

  if (stateFixed.addressPayFrom === undefined || stateFixed.addressPayFrom === null || stateFixed.addressPayFrom === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.addressYouPayFromMustBeFilled[state.language] });
    return { status: 'rejected' };
  }

  if (stateFixed.amountToBuy === undefined || stateFixed.amountToBuy === null || stateFixed.amountToBuy === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.amountToBuyMustBeFilled[state.language] });
    return { status: 'rejected' };
  }

  // 数量チェック
  if (stateFixed.amountToBuy > stateFixed.amountFree) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.amountToBuyMustBeWithinTheNumberOfStock[state.language] });
    return { status: 'rejected' };
  }

  if (stateFixed.amountToBuy < 1) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.amountToBuyMustBeEqualOrLargerThan1[state.language] });
    return { status: 'rejected' };
  }

  devLog('popupLayer', popupLayer);
  devLog('stateFixed', JSON.stringify(stateFixed));


  const clientTime = Date.now();
  const message = `I want to buy ${stateFixed.amountToBuy} monatoka points for ${stateFixed.priceMona} MONA per unit. I want to purchase them as ${stateFixed.addressMain}. I will send MONA from ${stateFixed.addressPayFrom}. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;

  if (keyPair !== undefined) {
    addressActual = stateFixed.addressMain;

    const result = signWithKey(state, dispatch, keyPair, message, state.networkMona);

    if (result.status === 'fulfilled') {
      signature = result.signature;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return 'rejected';
    }
  }
  else {
    // Mpurseのアドレスが合ってるかチェック
    const result = await window.mpurse.getAddress()
    .then( (result) => {
      addressActual = result;
      devLog('address', stateFixed.addressMain, stateFixed.addressPayFrom, addressActual, stateFixed.addressCheck);

      if (stateFixed.addressCheck === 'strict') {
        if (addressActual !== (addressType === 'addressMain' ? stateFixed.addressMain : stateFixed.addressPayFrom)) {
          dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressFilledAndTheAddressInWalletAreDifferent[state.language] });
          return 'rejected';
        }
        else {
          return 'fulfilled';
        }
      }
      else if (stateFixed.addressCheck === 'addressSecond') {
        if (addressActual !== stateFixed.addressMain && addressActual !== stateFixed.addressPayFrom) {
          dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressFilledAndTheAddressInWalletAreDifferent[state.language] });
          return 'rejected';
        }
        else {
          return 'fulfilled';
        }
      }
      else { // off
        return 'fulfilled';
      }
    })
    .catch( (error) => {
        dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressInYourWalletCanNotBeGotten[state.language] });
        return 'rejected';
    });

    if (result === 'rejected') {
      return { status: 'rejected' };
    }

    // 署名

    try {
      signature= await window.mpurse.signMessage(message).then( result => result );
    }
    catch (err) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return { status: 'rejected' };
    }
  }

  // GO！

  if (stateFixed.purchaseNo === null || stateFixed.purchaseNo === '') {
    bodyObj = {
      body: {
        addressType: addressType,
        addressMain: stateFixed.addressMain,
        addressMainActual: addressActual,
        addressPayFrom: stateFixed.addressPayFrom,
        amountToBuy: stateFixed.amountToBuy,
        priceMona: stateFixed.priceMona,
        monatokaPointAddress: stateFixed.monatokaPointAddress,
      }
    };

    bodyObj.body.clientTimeOfAddressMain = clientTime;
    bodyObj.body.signatureByAddressMain = signature;
    bodyObj.body.signatureVersionOfAddressMain = stateFixed.signatureVersion;

    // if (stateFixed.addressMain === stateFixed.addressPayFrom || addressActual === stateFixed.addressPayFrom) {
    //   bodyObj.body.clientTimeOfAddressPayFrom = clientTime;
    //   bodyObj.body.signatureByAddressPayFrom = signature;
    //   bodyObj.body.signatureVersionOfAddressPayFrom = stateFixed.signatureVersion;
    // }

    request.body = JSON.stringify(bodyObj);
  }
  else {
    bodyObj = {
      body: {
        addressType: addressType,
        addressMain: stateFixed.addressMain,
        addressPayFromActual: addressActual,
        purchaseNo: stateFixed.purchaseNo,
      }
    };

    bodyObj.body.clientTimeOfAddressPayFrom = clientTime;
    bodyObj.body.signatureByAddressPayFrom = signature;
    bodyObj.body.signatureVersionOfAddressPayFrom = stateFixed.signatureVersion;

    request.body = JSON.stringify(bodyObj);
  }

  request.url = 'https://' + process.env.REACT_APP_KOM_API_DOMAIN + '/purchase_point';
  request.method = 'POST';

  messages = {
    "you must accept the terms and conditions of the current version.": words.youMustAcceptTheTermsAndConditionsOfTheCurrentVersion[state.language],
    "internal server error": words.internalServerError[state.language],
    "bad signature": words.badSignature[state.language],
    "unknown signatureVersion": words.unknownSignatureVersion[state.language],
    "clientTime must be larger than last time.": words.clientTimeMustBeLargerThanLastTime[state.language],
    "this address is not permitted.": words.thisAddressIsNotPermitted[state.language],
    "this address is forbidden.": words.thisAddressIsForbidden[state.language],
    "order expired.": words.orderExpired[state.language],
    "out of service": words.outOfService[state.language],
    "user does not exist.": words.pleaseRegisterAsAUserOnTheSetupPage[state.language],
    "success": words.success[state.language],
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, undefined, undefined, 'notification', messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {
    const purchasePoint = response.body.purchasePoint;
    const sessionId = response.body.sessionId;
    const expirationOfSession = response.body.expirationOfSession;

    devLog('purchaseNo', purchasePoint.purchaseNo);

    // purchasePoint情報更新
    if (popupLayer === undefined || popupLayer === null) {
      dispatch({ type: 'setState', key: 'purchasePoint', value: purchasePoint });
    }

    // session情報更新
    if (addressType === 'addressMain') {
      dispatch({ type: 'setStateMultiLayers', keys: ['session', stateFixed.addressMain], value: {'sessionId': sessionId.addressMain, 'expirationOfSession': expirationOfSession.addressMain} });

      if (addressActual !== stateFixed.addressMain) {
        dispatch({ type: 'setStateMultiLayers', keys: ['session', addressActual], value: {'sessionId': sessionId.addressMainActual, 'expirationOfSession': expirationOfSession.addressMainActual} });
      }

      if (sessionId.addressPayFrom !== undefined) {
        dispatch({ type: 'setStateMultiLayers', keys: ['session', stateFixed.addressPayFrom], value: {'sessionId': sessionId.addressPayFrom, 'expirationOfSession': expirationOfSession.addressPayFrom} });
      }
    }
    else { // addressPayFrom
      dispatch({ type: 'setStateMultiLayers', keys: ['session', stateFixed.addressPayFrom], value: {'sessionId': sessionId.addressPayFrom, 'expirationOfSession': expirationOfSession.addressPayFrom} });

      if (addressActual !== stateFixed.addressPayFrom) {
        dispatch({ type: 'setStateMultiLayers', keys: ['session', addressActual], value: {'sessionId': sessionId.addressPayFromActual, 'expirationOfSession': expirationOfSession.addressPayFromActual} });
      }
    }

    // // オーダーNo.通知欄表示(全署名完了していたら)
    // if ( purchasePoint.signatureByAddressMain !== undefined && purchasePoint.signatureByAddressMain !== null && purchasePoint.signatureByAddressMain !== '' &&
    //      purchasePoint.signatureByAddressPayFrom !== undefined && purchasePoint.signatureByAddressPayFrom !== null && purchasePoint.signatureByAddressPayFrom !== '') {
    //   dispatch({ type: 'setNotification', key: 'notification', value: words.acceptedAsPurchaseNoX1[state.language] + purchasePoint.purchaseNo + words.acceptedAsPurchaseNoX2[state.language] });
    // }

    // const exhibitorName = state.usersGeneralIndex[stateFixed.addressMainExhibitor] !== undefined ? state.usersGeneralIndex[stateFixed.addressMainExhibitor].userName : stateFixed.addressMainExhibitor;
    // const cookiesNew = [
    //       {
    //         action: 'purchasePoint',
    //         addressType: 'addressMain',
    //         description: `${exhibitorName} ${tokenNameEither} ${stateFixed.amountToBuy}`,
    //         time: clientTime,
    //         address: stateFixed.addressMain
    //       },
    // ];

    // if (cookiesNew.every( cookie => cookie.address !== stateFixed.addressPayFrom )) {
    //   cookiesNew.push(
    //       {
    //         action: 'purchasePoint',
    //         addressType: 'addressPayFrom',
    //         description: `${exhibitorName} ${tokenNameEither} ${stateFixed.amountToBuy}`,
    //         time: clientTime,
    //         address: stateFixed.addressPayFrom
    //       },
    //   );
    // }

    // if (cookiesNew.every( cookie => cookie.address !== stateFixed.addressSendCardTo )) {
    //   cookiesNew.push(
    //       {
    //         action: 'purchasePoint',
    //         addressType: 'addressSendCardTo',
    //         description: `${exhibitorName} ${tokenNameEither} ${stateFixed.amountToBuy}`,
    //         time: clientTime,
    //         address: stateFixed.addressSendCardTo
    //       }
    //   );
    // }

    // setAddressesInCookie(state, dispatch, cookies, setCookie, stateFixed.addressMain, cookiesNew);

    // MONA送金

    if (purchasePoint.status === 'waitingForMona') {
      let result;
      let txid;

      dispatch({ type: 'setNotification', key: 'notification', value: words.goingToSendMona[state.language] });

      // モナ量計算

      const amountToBuyDecimal = new decimal(stateFixed.amountToBuy);
      const priceMonaDecimal = new decimal(stateFixed.priceMona);
      amountMona = amountToBuyDecimal.times(priceMonaDecimal).toNumber();
      devLog(`amountToBuy ${stateFixed.amountToBuy}, priceMona ${stateFixed.priceMona}, amountMona ${amountMona}`);

      // 送金！

      try {
        dispatch({ type: 'setState', key: 'accessing', value: true });
        result = await sendMonaSequence(
          state, dispatch, keyPair, stateFixed.addressPayFrom, stateFixed.monatokaPointAddress, amountMona,
          {
            provisionalTransactionFee: stateFixed.provisionalTransactionFee,
            transactionFeeUpperBound: stateFixed.transactionFeeUpperBound,
          }
        );
      }
      finally {
        dispatch({ type: 'setState', key: 'accessing', value: false });
      }

      if (result.status === 'fulfilled') {
        txid = result.body;
      }
      else {
        return result;
      }

      dispatch({ type: 'setNotification', key: 'notification', value: words.succeededToSendMona[state.language] + "\n" + txid });

      sendLog({
        action: 'sendMona',
        addressMain: stateFixed.addressMain,
        purchaseNo: purchasePoint.purchaseNo,
        signatureByAddressMainFromClient: purchasePoint.signatureByAddressMain,
        sendMonaTxidFromClient: txid,
        amountToBuy: stateFixed.amountToBuy,
      });
    }
  }
  else {
    return { status: 'rejected' };
  }

  return response;
}

// SEND MONA SEQUENCE
async function sendMonaSequence(state, dispatch, keyPair, addressFrom, addressTo, amountMona, { provisionalTransactionFee, transactionFeeUpperBound }) {
  let result;
  let utxos;
  let feeRate;
  let change;
  let unsignedTxHex;
  let signedTxHex;
  let txid;

  devLog('provisionalTransactionFee', provisionalTransactionFee);

  const amountMonaDecimal = new decimal(amountMona);
  const amountWatanabe = decimalAdjust( 'floor',  amountMonaDecimal.times(100000000).toNumber(), 0 ); 

  const provisionalTransactionFeeDecimal = new decimal(provisionalTransactionFee);
  const provisionalTransactionFeeWatanabe = decimalAdjust( 'floor',  provisionalTransactionFeeDecimal.times(100000000).toNumber(), 0 ); 

  // UTXO取得
  result = await getUtxo({clientParameters: state.config.clientParameters, address: addressFrom});

  if (result.status === 'fulfilled') {
    utxos = result.body;
  }
  else {
    devLog('failed to get UTXO.');
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSendMona[state.language] + result.error });
    return {
      status: 'rejected',
      error: 'failed to get UTXO.',
    };
  }

  // UTXO選定
  utxos.sort( (a, b) => a.satoshis - b.satoshis );
  const utxosSelected = selectUtxoWatanabe([...utxos], amountWatanabe + provisionalTransactionFeeWatanabe); // boundaryは概算。provisionalTransactionFeeには少し余裕をもたせるべし。
  devLog('utxosSelected', JSON.stringify(utxosSelected));

  if (utxosSelected === null) {
    devLog('short of MONA');
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSendMona[state.language] + '2' });
    return {
      status: 'rejected',
      error: 'short of MONA',
    };
  }

  // UTX raw transaction取得
  result = await getRawTransaction(state, utxosSelected);

  if (result.status === 'rejected') {
    devLog('failed to get unspent raw transactions.');
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSendMona[state.language] + '3' });
    return {
      status: 'rejected',
      error: 'failed to get unspent raw transactions.',
    };
  }

  // fee rate取得
  result = await getFeeRate({ clientParameters: state.config.clientParameters });

  if (result.status === 'fulfilled') {
    feeRate = result.body;
  }
  else {
    devLog('failed to get fee rate.');
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSendMona[state.language] + '4' });
    return {
      status: 'rejected',
      error: 'failed to get fee rate.',
    };
  }

  // お釣り計算
  // const amountMonaDecimal = new decimal(amountMona);
  const baseAmountWatanabe = decimalAdjust( 'floor',  amountMonaDecimal.times(100000000).toNumber(), 0 ); 
  const approximatedTransactionBytes = 1000;

  result = calculateChangeWatanabe(
    utxosSelected,
    baseAmountWatanabe,
    feeRate,
    approximatedTransactionBytes,
    transactionFeeUpperBound,
  );

  if (result.status === 'fulfilled') {
    change = result.body.change;
  }
  else {
    devLog('failed to calculate change.');
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSendMona[state.language] + '5' });
    return {
      status: 'rejected',
      error: result.error,
    };
  }

  // トランザクション作成
  const inputs = utxosSelected.map( utxo => {
    return {
      txid: utxo.txid,
      vout: utxo.vout,
      rawTransaction: utxo.rawTransaction,
    };
  });

  devLog('inputs', JSON.stringify(inputs));

  const outputs = [
    {
      address: addressTo,
      amount: baseAmountWatanabe,
    },
    {
      address: addressFrom,
      amount: change,
    },
  ];

  devLog('outputs', JSON.stringify(outputs));

  result = buildUnsignedTransactionSendMona(state.networkMona, inputs, outputs);

  if (result.status === 'fulfilled') {
    unsignedTxHex = result.body;
  }
  else {
    devLog('failed to build transaction.');
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSendMona[state.language] + '6' });
    return {
      status: 'rejected',
      error: result.error,
    };
  }

  // トランザクション署名

  if (keyPair !== undefined && keyPair !== null) {
    result = signTransaction(state.networkMona, unsignedTxHex, keyPair);

    if (result.status === 'fulfilled') {
      signedTxHex = result.body;
    }
    else {
      devLog('failed to sign transaction.');
      dispatch({ type: 'setNotification', key: 'notification', value: `${words.failedToSignTransaction[state.language]} ${words.pleaseLogin[state.language]}` });
      throw wrapErrorWithCause('failedToSignTransaction', result.error);
    }
  }
  else if (window.mpurse) { // Mpurse
    result = await window.mpurse.signRawTransaction(unsignedTxHex)
    .then( async (result) => {
      devLog('succeeded to sign transaction.');
      signedTxHex = result;
    })
    .catch( (error) => {
      devLog('failed to sign transaction with Mpurse.', error);
      const message = notificationMessageWithError(words.failedToSignTransaction[state.language], error);
      dispatch({ type: 'setNotification', key: 'notification', value: message });
      throw wrapErrorWithCause('failedToSignTransaction', error);
    });
  }
  else {
    devLog('failed to sign transaction.; no keyPair and no Mpurse.');
    dispatch({ type: 'setNotification', key: 'notification', value: `${words.failedToSignTransaction[state.language]} ${words.pleaseLogin[state.language]}` });
    throw new Error('no keyPair and no Mpurse.');
  }

  // ブロードキャスト
  result = await broadcastTransaction({
    clientParameters: state.config.clientParameters,
    signedTxHex,
  });

  if (result.status === 'fulfilled') {
    txid = result.body;
  }
  else {
    devLog('failed to broadcast transaction.');
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSendMona[state.language] + '8' });
    return {
      status: 'rejected',
      error: 'failed to broadcast transaction.',
    };
  }

  return {
    status: 'fulfilled',
    body: txid,
  };
}

export {
  handleClickGetPointSum,
  handleClickGetPointHistory,
  handleClickClearPurchase,
  handleClickSignPurchase,
  sendMonaSequence,
};
